import classnames from "classnames";
import React, { type FC } from "react";
import { HistoryContextProvider } from "src/components/Contexts/History/Provider";
import styles from "src/styles.module.scss";
import HistoryTable from "./HistoryTable";

const History: FC = () => {
  return (
    <HistoryContextProvider>
      <div className={classnames(styles.ma_16)}>
        <HistoryTable />
      </div>
    </HistoryContextProvider>
  );
};

export default History;
